var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConversationBroadcast = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 14.7C1.305 14.7 0.8814 14.5239 0.5292 14.1717C0.177 13.8195 0.0006 13.3956 0 12.9V2.10005C0 1.60505 0.1764 1.18145 0.5292 0.829249C0.882 0.477049 1.3056 0.300649 1.8 0.300049H16.2C16.695 0.300049 17.1189 0.476449 17.4717 0.829249C17.8245 1.18205 18.0006 1.60565 18 2.10005V12.9C18 13.395 17.8239 13.8189 17.4717 14.1717C17.1195 14.5245 16.6956 14.7006 16.2 14.7H1.8ZM8.1 8.40005H15.3V3.00005H8.1V8.40005Z",
    fill: "#0E1F3C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConversationBroadcast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/conversationBroadcast.031cb01bd4e9e7c78f892d43b0fee4e2.svg";